"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNPUBLISH = exports.RENEW_CERTIFICATION = exports.CERTIFICATION = exports.RENEW_LISTING = exports.UPDATE_LISTING = exports.NEW_LISTING = void 0;
var NEW_LISTING = 'NEW_LISTING';
exports.NEW_LISTING = NEW_LISTING;
var UPDATE_LISTING = 'UPDATE_LISTING';
exports.UPDATE_LISTING = UPDATE_LISTING;
var RENEW_LISTING = 'RENEW_LISTING';
exports.RENEW_LISTING = RENEW_LISTING;
var CERTIFICATION = 'CERTIFICATION';
exports.CERTIFICATION = CERTIFICATION;
var RENEW_CERTIFICATION = 'RENEW_CERTIFICATION';
exports.RENEW_CERTIFICATION = RENEW_CERTIFICATION;
var UNPUBLISH = 'UNPUBLISH';
exports.UNPUBLISH = UNPUBLISH;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/submissions/SubmissionTypes.js
// module id = 757
// module chunks = 209 210 211 212